<app-header></app-header>
<app-message-box [title]="title">
  <p>We have detected that your browser has Web Storage (DOM Storage) disabled. We need Web Storage enabled in order to improve your experience.</p>
</app-message-box>

